export default "__VITE_ASSET__BGTvDQdO__"